module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [(_vm.withTitle) ? _c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": "",
      "dark": "",
      "extended": _vm.$vuetify.breakpoint.xs
    }
  }, [_c('v-toolbar-title', [_c('span', [_vm._v(_vm._s(_vm.clientFullName))])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? [(_vm.mailchimpIntegration && _vm.clientEmail && _vm.relationshipId) ? _c('mailchimp-chip', {
    attrs: {
      "email": _vm.clientEmail,
      "relationship-id": _vm.relationshipId
    }
  }) : _vm._e(), _vm._v(" "), (_vm.physitrackIntegration && _vm.relationshipId) ? _c('physitrack-embed', {
    attrs: {
      "relationship-id": _vm.relationshipId
    }
  }) : _vm._e()] : _c('template', {
    slot: "extension"
  }, [(_vm.mailchimpIntegration && _vm.clientEmail && _vm.relationshipId) ? _c('mailchimp-chip', {
    attrs: {
      "email": _vm.clientEmail,
      "relationship-id": _vm.relationshipId
    }
  }) : _vm._e(), _vm._v(" "), (_vm.physitrackIntegration && _vm.relationshipId) ? _c('physitrack-embed', {
    attrs: {
      "relationship-id": _vm.relationshipId
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.client && _vm.client.id) ? [_c('v-btn', {
    attrs: {
      "dark": "",
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.sharingdialog = true
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("share")])], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "360"
    },
    model: {
      value: (_vm.sharingdialog),
      callback: function($$v) {
        _vm.sharingdialog = $$v
      },
      expression: "sharingdialog"
    }
  }, [_c('v-card', {
    attrs: {
      "tile": ""
    }
  }, [_c('v-card-title', {
    staticClass: "py-1 overline"
  }, [_vm._v("\n            Sharing\n            "), _c('help-popover', [_vm._v("\n              Members of spaces with which this client is shared will be able to view and edit the client\n              as well as creating appointments and invoices for them. "), _c('br'), _vm._v("\n              Only the owner is able to change sharing settings\n            ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.sharingdialog = false
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('request-status', {
    attrs: {
      "request": _vm.requests.share
    }
  }), _vm._v(" "), _c('v-card-text', [(_vm.ownerId) ? _c('sharing-information', {
    staticClass: "ml-3",
    attrs: {
      "context": _vm.client.context,
      "owner-id": _vm.ownerId,
      "space-ids": _vm.client.spaces
    }
  }) : _vm._e(), _vm._v(" "), _c('space-picker', {
    attrs: {
      "required": "",
      "with-select": false,
      "label": "Contact is shared with these spaces",
      "direction": "bottom"
    },
    model: {
      value: (_vm.client.spaces),
      callback: function($$v) {
        _vm.$set(_vm.client, "spaces", $$v)
      },
      expression: "client.spaces"
    }
  }), _vm._v(" "), _c('v-alert', {
    staticClass: "py-1 caption lighten-1 mt-3",
    attrs: {
      "type": "info",
      "value": true,
      "dismissible": ""
    }
  }, [_c('strong', [_vm._v("Note:")]), _vm._v("\n              only an owner of these spaces can change the sharing preferences\n            ")])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": this.requests.share.loading,
      "color": "primary"
    },
    on: {
      "click": _vm.setSharing
    }
  }, [(_vm.client.spaces.length === 0) ? _c('span', [_vm._v("Clear sharing")]) : _c('span', [_vm._v("Update sharing")])])], 1)], 1)], 1)] : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.client && _vm.client.id) ? [(!_vm.isCompact) ? _c('v-tabs', {
    attrs: {
      "vertical": "",
      "dark": "",
      "show-arrows": "",
      "grow": ""
    },
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_vm._l((_vm.items), function(item, index) {
    return _c('v-tab', {
      key: item.id
    }, [(index === 0) ? _c('v-icon', [_vm._v("home")]) : _c('span', [_vm._v(_vm._s(item.title))])], 1)
  }), _vm._v(" "), _c('v-tabs-items', {
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, _vm._l((_vm.items), function(item, index) {
    return _c('v-tab-item', {
      key: item.id
    }, [(item.component && _vm.activeTab === index) ? _c(item.component, _vm._g(_vm._b({
      tag: "component",
      attrs: {
        "lazy": ""
      },
      on: {
        "report": _vm.showReport,
        "close": function($event) {
          return _vm.$emit("close")
        },
        "click:share": function($event) {
          _vm.sharingdialog = true
        },
        "goto": _vm.gotoTabName
      }
    }, 'component', item.attrs, false), item.evnts || {}), [_c('template', {
      slot: "toolbar-buttons"
    }, [(item.id === "Statement") ? _c('v-btn', {
      staticClass: "hidden-xs-only",
      attrs: {
        "flat": "",
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.showReport('account')
        }
      }
    }, [_vm._v("Print report\n              ")]) : _vm._e(), _vm._v(" "), (item.id === "Notes") ? _c('v-btn', {
      staticClass: "hidden-xs-only mr-5",
      attrs: {
        "flat": "",
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.showReport('client-report')
        }
      }
    }, [_vm._v("Print report\n              ")]) : _vm._e()], 1)], 2) : _vm._e()], 1)
  }), 1)], 2) : _c('v-expansion-panel', {
    staticClass: "elevation-0",
    attrs: {
      "focusable": ""
    },
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, _vm._l((_vm.items), function(item, index) {
    return _c('v-expansion-panel-content', {
      key: item.id,
      scopedSlots: _vm._u([{
        key: "header",
        fn: function() {
          return [_c('div', {
            staticClass: "subheading"
          }, [_vm._v("\n            " + _vm._s(item.title))])]
        },
        proxy: true
      }], null, true)
    }, [_vm._v(" "), (item.component && _vm.activeTab === index) ? _c(item.component, _vm._g(_vm._b({
      tag: "component",
      attrs: {
        "lazy": ""
      },
      on: {
        "click:share": function($event) {
          _vm.sharingdialog = true
        },
        "goto": _vm.gotoTabName
      }
    }, 'component', item.attrs, false), item.evnts || {})) : _vm._e()], 1)
  }), 1)] : _vm._e(), _vm._v(" "), (_vm.client && _vm.client.client) ? _c('v-footer', {
    staticClass: "px-3 mt-4"
  }, [_c('small', [_vm._v("\n    " + _vm._s(_vm.clientFullName) + ", Client #" + _vm._s(_vm.client.client.id) + ". Rel #" + _vm._s(_vm.client.id) + "\n    ")]), _vm._v(" "), _c('v-spacer')], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "500"
    },
    model: {
      value: (_vm.showReportDialog),
      callback: function($$v) {
        _vm.showReportDialog = $$v
      },
      expression: "showReportDialog"
    }
  }, [_c('report-form', {
    attrs: {
      "relationship-id": _vm.relationshipId,
      "report-name": _vm.reportName
    },
    on: {
      "close": function($event) {
        _vm.showReportDialog = false
      }
    }
  })], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8476259c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/client/ClientDetails.vue
// module id = 1489
// module chunks = 9